import Vue from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import CoreFeaturesSection from "./components/CoreFeaturesSection.vue";
import i18n from "./i18n";
import router from "./router";
import "./styles/global.css";
import "./styles/motion.css";
import reveal from "./directives/reveal";

Vue.use(Antd);
Vue.directive("reveal", reveal);
Vue.config.productionTip = false;
Vue.component("CoreFeaturesSection", CoreFeaturesSection);

new Vue({
  i18n,
  router,
  render: (h) => h(App)
}).$mount("#app");
